import React from 'react';
import { Form, TextAreaBox, DatePicker, CheckBox } from 'fw/forms';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import { DocumentUpload } from 'areas/shared/controls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import * as FormManager from 'fw/forms/form/FormManager';
import { Tooltip, Button } from 'fw/components'
import { TooltipCode } from 'areas/shared/consts';

class BusinessCertifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return { 
            form: this.props.stepData,
            tooltips: this.props.stepInfo.tooltips 
        };
    };

    updatePostData = (form, dirty) => {
        this.evaluateBlankNmsdc(form);
        this.evaluateBlankWbenc(form);
        this.evaluateBlankNglcc(form);
        this.evaluateNoneOfAbove(form);
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    evaluateBlankNmsdc(form) {
        if (!form.nmsdc) {
            form.nmsdcStorageToken = null;
            form.nmsdcFileName = null;
            form.nmsdcExpirationDate = null;
        }
    }

    evaluateBlankWbenc(form) {
        if (!form.wbenc) {
            form.wbencStorageToken = null;
            form.wbencFileName = null;
            form.wbencExpirationDate = null;
        }
    }

    evaluateBlankNglcc(form) {
        if (!form.nglcc) {
            form.nglccStorageToken = null;
            form.nglccFileName = null;
            form.nglccExpirationDate = null;
        }
    }

    evaluateNoneOfAbove(form) {
        if (form.none) {
            form.nmsdc = false;
            form.nmsdcStorageToken = null;
            form.nmsdcFileName = null;
            form.nmsdcExpirationDate = null;
            form.wbenc = false;
            form.wbencStorageToken = null;
            form.wbencFileName = null;
            form.wbencExpirationDate = null;
            form.nglcc = false;
            form.nglccStorageToken = null;
            form.nglccFileName = null;
            form.nglccExpirationDate = null;
            form.cve = false;
            form.sbA8 = false;
            form.sba = false;
            form.dvbe = false;
            form.naVOBA = false;
            form.di = false;
        }
    }

    handleNmsdcUploadChange = (file) => {
        let form = this.state.form;
        form.nmsdcStorageToken = file.storageToken;
        form.nmsdcFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleNmsdcUploadRemove = () => {
        let form = this.state.form;
        form.nmsdcExpirationDate = "";
    }

    handleWbencUploadChange = (file) => {
        let form = this.state.form;
        form.wbencStorageToken = file.storageToken;
        form.wbencFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleWbencUploadRemove = () => {
        let form = this.state.form;
        form.wbencExpirationDate = "";
    }

    handleNglccUploadChange = (file) => {
        let form = this.state.form;
        form.nglccStorageToken = file.storageToken;
        form.nglccFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleNglccUploadRemove = () => {
        let form = this.state.form;
        form.nglccExpirationDate = "";
    }

    handleDescriptionChange = (value, index) => {
        let form = this.state.form;
        form.otherFiles[index].description = value;

        this.updatePostData(form, true)
    };

    handleOtherDocumentRemove = (index) => {
        let form = this.state.form;

        form.otherFiles[index].description = "";
    };

    handleUploadOtherFileChange = (file, index) => {
        let form = this.state.form;
        form.otherFiles[index].storageToken = file.storageToken;
        form.otherFiles[index].fileName = file.fileName;

        this.updatePostData(form, true)
    }

    handleAddAnotherCertification = () => {
        let form = this.state.form;
        form.otherFiles.push({
            businessCertificationOtherFileId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    }

    handleRemoveOtherDocument = (i) => {
        let form = this.state.form;
        form.otherFiles.splice(i, 1);

        this.updatePostData(form, true);
    }

    renderOtherFiles = () => {
        return this.state.form.otherFiles.map((item, index) => (
            <Row key={item.businessCertificationOtherFileId} style={{ marginBottom: 10 }}>
                <Col md={11}>
                    <DocumentUpload
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadOtherFileChange(file, index)}
                        onRemove={() => this.handleOtherDocumentRemove(index)}
                    />
                    <TextAreaBox
                        maxLength={500}
                        placeholder="Briefly describe your Uploaded Certification here..."
                        value={item.description}
                        onChange={value => this.handleDescriptionChange(value, index)} />
                </Col>
                <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
					<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(index)} title="Remove Certification">
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
                </Col>
            </Row>
        ));
    };

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    render() {
        return (
            <Form
                onChange={this.updatePostData}
                values={this.state.form}
                unsavedChangesWarning={true}
                disabled={this.props.stepInfo.readonly}
                ref={(form) => { this._form = form }}>
                <div>
                    <ContentBody>
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={12}>
                                        <h3 style={{ position: 'relative' }}>Business Certification – <small>Please select all that apply to your business</small> <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                                        <hr />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='nmsdc' tip={this.setTip(TooltipCode.CERTIFICATION.NMSDC)} disabled={this.state.form.none} label='NMSDC - <a href="https://www.nmsdc.org/" target="_blank">National Minority Supplier Development Council</a>' />
                                                    {this.state.form !== null && this.state.form.nmsdc ? (
                                                        <React.Fragment>
                                                            <DocumentUpload
                                                                storageToken={this.state.form.nmsdcStorageToken}
                                                                fileName={this.state.form.nmsdcFileName}
                                                                onChange={this.handleNmsdcUploadChange}
                                                                onRemove={this.handleNmsdcUploadRemove} />
                                                            <Row>
                                                                <Col md={6}>
                                                                    <div className="input-group">
                                                                        <DatePicker className='dpThin'
                                                                            name='nmsdcExpirationDate'
                                                                            placeholder='Expiration Date' />
                                                                        {this.setTip(TooltipCode.CERTIFICATION.NMSDCEXPDATE) && <span className="input-group-addon" style={{ border: 0 }}>
                                                                            <Tooltip tip={this.setTip(TooltipCode.CERTIFICATION.NMSDCEXPDATE)}/>
                                                                        </span>}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='wbenc' tip={this.setTip(TooltipCode.CERTIFICATION.WBENC)} disabled={this.state.form.none} label='WBENC - <a href="https://www.wbenc.org/" target="_blank">Women’s Business Enterprise National Council</a>' />
                                                    {this.state.form !== null && this.state.form.wbenc ? (
                                                        <React.Fragment>
                                                            <DocumentUpload
                                                                storageToken={this.state.form.wbencStorageToken}
                                                                fileName={this.state.form.wbencFileName}
                                                                onChange={this.handleWbencUploadChange}
                                                                onRemove={this.handleWbencUploadRemove} />
                                                            <Row>
                                                                <Col md={6}>
                                                                    <div className="input-group">
                                                                        <DatePicker className='dpThin'
                                                                            name='wbencExpirationDate'
                                                                            placeholder='Expiration Date' />
                                                                        {this.setTip(TooltipCode.CERTIFICATION.WBENCEXPDATE) && <span className="input-group-addon" style={{ border: 0 }}>
                                                                            <Tooltip tip={this.setTip(TooltipCode.CERTIFICATION.WBENCEXPDATE)}/>
                                                                        </span>}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='nglcc' tip={this.setTip(TooltipCode.CERTIFICATION.NGLCC)} disabled={this.state.form.none} label='NGLCC - <a href="https://www.nglcc.org/" target="_blank">National Gay &amp; Lesbian Chamber of Commerce</a>' />
                                                    {this.state.form !== null && this.state.form.nglcc ? (
                                                        <React.Fragment>
                                                            <DocumentUpload
                                                                storageToken={this.state.form.nglccStorageToken}
                                                                fileName={this.state.form.nglccFileName}
                                                                onChange={this.handleNglccUploadChange}
                                                                onRemove={this.handleNglccUploadRemove} />
                                                            <Row>
                                                                <Col md={6}>
                                                                    <div className="input-group">
                                                                        <DatePicker className='dpThin'
                                                                            name='nglccExpirationDate'
                                                                            placeholder='Expiration Date' />
                                                                        {this.setTip(TooltipCode.CERTIFICATION.NGLCCEXPDATE) && <span className="input-group-addon" style={{ border: 0 }}>
                                                                            <Tooltip tip={this.setTip(TooltipCode.CERTIFICATION.NGLCCEXPDATE)}/>
                                                                        </span>}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='cve' tip={this.setTip(TooltipCode.CERTIFICATION.CVE)} disabled={this.state.form.none} label='CVE - <a href="https://www.va.gov/osdbu/verification/" target="_blank">Veterans Administration</a>' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='sbA8' tip={this.setTip(TooltipCode.CERTIFICATION.SBA8)} disabled={this.state.form.none} label='SBA - <a href="https://www.sba.gov/federal-contracting/contracting-assistance-programs/8a-business-development-program" target="_blank">8(a) Socially and Economically Disadvantaged</a>' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='sba' tip={this.setTip(TooltipCode.CERTIFICATION.SBAHUBZONE)} disabled={this.state.form.none} label='SBA - <a href="https://www.sba.gov/federal-contracting/contracting-assistance-programs/hubzone-program" target="_blank">HUBZone</a>' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='dvbe' tip={this.setTip(TooltipCode.CERTIFICATION.DISVETBUSENT)} disabled={this.state.form.none} label='DVBE - <a href="https://www.dgs.ca.gov/" target="_blank">Disabled Veterans Business Enterprise</a>' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='naVOBA' tip={this.setTip(TooltipCode.CERTIFICATION.NAVOBA)} disabled={this.state.form.none} label='NaVOBA - <a href="https://navoba.org/" target="_blank">National Veteran-Owned Business Association</a>' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='di' tip={this.setTip(TooltipCode.CERTIFICATION.DISABILITY)} disabled={this.state.form.none} label='DI - <a href="https://disabilityin.org/" target="_blank">DisabilityIN</a>' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <CheckBox inline name='none' tip={this.setTip(TooltipCode.CERTIFICATION.NONEOFABOVE)} label='None of the above' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6}>
                                        <Row>
                                            <Col md={12}>
                                                <label>&nbsp;</label>
                                                {this.state.form.otherFiles != null && this.state.form.otherFiles.length > 0 && (
                                                    <FormGroup>
                                                        {this.renderOtherFiles()}
                                                    </FormGroup>
                                                )}
                                                {(this.state.form.otherFiles == null || this.state.form.otherFiles.length < 5) &&
													<Button type="button" bsStyle="link" onClick={this.handleAddAnotherCertification}>
                                                        Add another Certification
													</Button>
												}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </ContentBody>
                </div>
            </Form>
        )
    }
}

export default BusinessCertifications;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/businessCertifications/BusinessCertifications.js